import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { EmployeeContractManagerLink } from './employee-contract-manager-link'
import { employeeContractManagerLinkActions } from './employee-contract-manager-link.actions'
import * as fromEmployeeContractManagerLink from './employee-contract-manager-link.reducer'
import { EmployeeContractManagerLinkService } from './employee-contract-manager-link.service'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { exhaustMap, map } from 'rxjs/operators'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'

@Injectable()
export class EmployeeContractManagerLinkEffects extends ResourceEffects<EmployeeContractManagerLink> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private employeeContractManagerLinkService: EmployeeContractManagerLinkService
  ) {
    super(
      fromEmployeeContractManagerLink.FEATURE_NAME,
      employeeContractManagerLinkService,
      employeeContractManagerLinkActions,
      actions$
    )
  }
}
